import { render, staticRenderFns } from "./chiaraStarterPage.vue?vue&type=template&id=837733c0&"
import script from "./chiaraStarterPage.vue?vue&type=script&lang=js&"
export * from "./chiaraStarterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports